import { useState } from "react";

const fieldClass = "rounded-lg border border-white/15 bg-zinc-900 px-3 py-2 text-sm text-white";

export default function AdminPagedList({ items = [], renderItem, dateField = "created_at", tableRows = false }) {
  const [query, setQuery] = useState("");
  const [period, setPeriod] = useState("all");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [size, setSize] = useState(20);
  const [position, setPosition] = useState({ key: "", page: 1 });
  const hasDates = items.some((item) => item?.[dateField]);
  const normalize = (value) => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const needle = normalize(query.trim());
  const start = period === "custom" ? (from ? new Date(`${from}T00:00:00`).getTime() : -Infinity) : Date.now() - Number(period) * 86400000;
  const end = period === "custom" ? (to ? new Date(`${to}T23:59:59.999`).getTime() : Infinity) : Date.now();
  const filtered = items.filter((item) => {
    if (needle && !Object.values(item || {}).some((value) => ["string", "number"].includes(typeof value) && normalize(value).includes(needle))) return false;
    if (period !== "all" && hasDates) {
      const date = new Date(item?.[dateField]).getTime();
      if (!Number.isFinite(date) || date < start || date > end) return false;
    }
    return true;
  });
  // Reset navigation when the upstream search, ordering or local filters change.
  const key = JSON.stringify([query, period, from, to, size, filtered.map((item) => item.id || item.event_id || item.question_id || item.name || item.code)]);
  const pages = Math.max(1, Math.ceil(filtered.length / size));
  const page = position.key === key ? Math.min(position.page, pages) : 1;
  const go = (next) => setPosition({ key, page: Math.max(1, Math.min(next, pages)) });
  const controls = (bottom = false) => (
    <div className="col-span-full flex w-full flex-wrap items-center gap-2 rounded-xl border border-white/10 bg-zinc-950/60 p-3 text-sm text-zinc-300" style={{ flexBasis: "100%" }}>
      {!bottom && <>
        <input aria-label="Buscar nesta lista" placeholder="Buscar nesta lista" value={query} onChange={(e) => setQuery(e.target.value)} className={fieldClass} />
        {hasDates && <>
          <select aria-label="Período da lista" value={period} onChange={(e) => setPeriod(e.target.value)} className={fieldClass}>
            <option value="all">Todo o período</option>
            {[30, 60, 90].map((days) => <option key={days} value={days}>Últimos {days} dias</option>)}
            <option value="custom">Período personalizado</option>
          </select>
          {period === "custom" && <>
            <input type="date" aria-label="Data inicial" value={from} max={to || undefined} onChange={(e) => setFrom(e.target.value)} className={fieldClass} />
            <input type="date" aria-label="Data final" value={to} min={from || undefined} onChange={(e) => setTo(e.target.value)} className={fieldClass} />
          </>}
        </>}
        <label className="flex items-center gap-2">Por página
          <select value={size} onChange={(e) => setSize(Number(e.target.value))} className={fieldClass}>
            {[10, 20, 50, 100].map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
        </label>
      </>}
      <span className="ml-auto" aria-live="polite">{filtered.length ? (page - 1) * size + 1 : 0}–{Math.min(page * size, filtered.length)} de {filtered.length}</span>
      <button type="button" onClick={() => go(page - 1)} disabled={page === 1} className={`${fieldClass} disabled:opacity-40`}>Anterior</button>
      <span>{page} / {pages}</span>
      <button type="button" onClick={() => go(page + 1)} disabled={page === pages} className={`${fieldClass} disabled:opacity-40`}>Próxima</button>
    </div>
  );
  const wrap = (content) => tableRows ? <tr><td colSpan={20}>{content}</td></tr> : content;
  return <>
    {wrap(controls())}
    {filtered.slice((page - 1) * size, page * size).map(renderItem)}
    {!filtered.length && wrap(<p className="col-span-full p-4 text-sm text-zinc-400">Nenhum registro encontrado com esses filtros.</p>)}
    {pages > 1 && wrap(controls(true))}
  </>;
}

export function paged(items, renderItem, options = {}) {
  return <AdminPagedList items={items} renderItem={renderItem} {...options} />;
}

export function pagedRows(items, renderItem) {
  return <AdminPagedList items={items} renderItem={renderItem} tableRows />;
}
